import { createContext } from 'react';

export const ModuleContext = createContext();